export default __webpack_public_path__ + "static/media/136.81a2b304.jpg";